import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { connect, FormikValues } from 'formik'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Button from '@/components/Button'
import Modal from '@/components/Modal'

import messages from './messages'

const StyledActionBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 30px;
  flex-wrap: wrap;

  button {
    font-size: 0.9rem;
  }
`

interface SaveOperationStepProps {
  isOpen?: boolean
  onCancel?: (showValidation?: boolean) => void
  onSave?: () => void
}

const SaveOperationModal = ({
  isOpen = false,
  onSave = () => {},
  onCancel = () => {}
}: SaveOperationStepProps & FormikValues) => {
  const intl = useIntl()

  return (
    <Modal isOpen={isOpen} onClose={onCancel} size="sm">
      <div className="py-2">
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationTriangleIcon className="h-6 w-6 text-orange-600" aria-hidden="true" />
          </div>
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <div className="text-base font-semibold leading-6 text-gray-900">Unsaved changes</div>
            <div className="mt-2">
              <p className="text-sm text-gray-500">{intl.formatMessage(messages.saveStepDescription)}</p>
            </div>
          </div>
        </div>
        <StyledActionBlock>
          <Button
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              onCancel(false)
            }}
            color={'secondary'}
          >
            <span>{intl.formatMessage(messages.continueEditing)}</span>
          </Button>
          <Button onClick={onSave} color={'primary'}>
            <span>{intl.formatMessage(messages.saveClose)}</span>
          </Button>
        </StyledActionBlock>
      </div>
    </Modal>
  )
}

SaveOperationModal.displayName = 'SaveOperationModal'

export default connect(SaveOperationModal)
